import React, { useState, useEffect } from 'react';
import { TbHome } from "react-icons/tb";
import { RiInformation2Fill } from "react-icons/ri";
import { MdContactSupport } from "react-icons/md";
const NavigationBar = () => {
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const userType = sessionStorage.getItem('userType');
    setIsProfileVisible(!!userType);
    setIsLoggedIn(!!userType);
  }, []);

  // Function to toggle mobile menu using React state
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="px-4 py-2 relative">
      <nav className="bg-transparent text-white sticky top-0 z-50 rounded-2xl p-3 mx-2 mt-2 transition-all duration-300">
        <div className="container mx-auto">
          <div className="flex justify-between items-center">
            {/* Logo Area could go here */}

            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-8">
              <a href="/" className="text-white text-xl no-underline group relative overflow-hidden py-2 px-4 font-semibold tracking-wide transition-all duration-200 hover:scale-105">
                <span className="flex items-center space-x-2 relative z-10">
                  <TbHome />
                  <span>Home</span>
                </span>
                <span className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-green-400 to-green-600 group-hover:w-full transition-all duration-300"></span>
              </a>

              <a href="/about" className="text-white text-xl no-underline group relative overflow-hidden py-2 px-4 font-semibold tracking-wide transition-all duration-200 hover:scale-105">
                <span className="flex items-center space-x-2 relative z-10">
                  <RiInformation2Fill />
                  <span>About</span>
                </span>
                <span className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-green-400 to-green-600 group-hover:w-full transition-all duration-300"></span>
              </a>

              <a href="/contact" className="text-white text-xl no-underline group relative overflow-hidden py-2 px-4 font-semibold tracking-wide transition-all duration-200 hover:scale-105">
                <span className="flex items-center space-x-2 relative z-10">
                  <MdContactSupport />
                  <span>Contact</span>
                </span>
                <span className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-green-400 to-green-600 group-hover:w-full transition-all duration-300"></span>
              </a>
            </div>

            {/* User and Mobile Menu */}
            <div className="hidden md:flex items-center space-x-4">
              <a href={isLoggedIn ? "/profile" : "/Order"} className="text-white px-3 py-1.5 rounded-xl font-semibold no-underline hover:bg-green-600 transition duration-200 flex items-center space-x-2 shadow-lg transform hover:scale-105 border border-green-200">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
                <span className="hidden lg:inline">
                  {isLoggedIn ? "Profile" : "Sign In"}
                </span>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Modern Mobile Bottom Navigation Bar */}
      <nav className="fixed bottom-2 left-1/2 -translate-x-1/2 z-50 w-[98vw] max-w-md bg-white rounded-2xl shadow-2xl flex justify-between items-center px-2 py-1 md:hidden border border-green-100" style={{boxShadow: '0 2px 24px 0 rgba(16,185,129,0.12)'}}>
        <a href="/" className="no-underline flex flex-col items-center flex-1 py-2 text-green-600 hover:text-green-800 transition-colors">
          <TbHome size={24} />
          <span className="text-xs mt-1 font-semibold">Home</span>
        </a>
        <a href="/about" className="no-underline flex flex-col items-center flex-1 py-2 text-green-600 hover:text-green-800 transition-colors">
          <RiInformation2Fill size={24} />
          <span className="text-xs mt-1 font-semibold">About</span>
        </a>
        <a href="/contact" className="no-underline flex flex-col items-center flex-1 py-2 text-green-600 hover:text-green-800 transition-colors">
          <MdContactSupport size={24} />
          <span className="text-xs mt-1 font-semibold">Contact</span>
        </a>
        <a href={isLoggedIn ? "/profile" : "/Order"} className="no-underline flex flex-col items-center flex-1 py-2 text-green-600 hover:text-green-800 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
          </svg>
          <span className="text-xs mt-1 font-semibold">{isLoggedIn ? "Profile" : "Account"}</span>
        </a>
      </nav>
    </div>
  );
};

export default NavigationBar;